import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../../services/navigation.service';
import { SearchService } from '../../../../services/search.service';
import { AuthService } from '../../../../services/auth.service';
import { SettingsService } from 'src/app/shared/services/data/settings.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header-sidebar-large',
  templateUrl: './header-sidebar-large.component.html',
  styleUrls: ['./header-sidebar-large.component.scss']
})
export class HeaderSidebarLargeComponent implements OnInit {

    notifications: any[];
    user: any;
    selectedSuiteCode: string;
    showSuiteSelection: boolean;
    constructor(
      private navService: NavigationService,
      public searchService: SearchService,
      private auth: AuthService,
      private settingsService : SettingsService,
      private toastr: ToastrService,
      private modalService: NgbModal
    ) {
      this.notifications = [
        {
          icon: 'i-Speach-Bubble-6',
          title: 'New message',
          badge: '3',
          text: 'James: Hey! are you busy?',
          time: new Date(),
          status: 'primary',
          link: '/chat'
        },
        {
          icon: 'i-Receipt-3',
          title: 'New order received',
          badge: '$4036',
          text: '1 Headphone, 3 iPhone x',
          time: new Date('11/11/2018'),
          status: 'success',
          link: '/tables/full'
        },
        {
          icon: 'i-Empty-Box',
          title: 'Product out of stock',
          text: 'Headphone E67, R98, XL90, Q77',
          time: new Date('11/10/2018'),
          status: 'danger',
          link: '/tables/list'
        },
        {
          icon: 'i-Data-Power',
          title: 'Server up!',
          text: 'Server rebooted successfully',
          time: new Date('11/08/2018'),
          status: 'success',
          link: '/dashboard/v2'
        },
        {
          icon: 'i-Data-Block',
          title: 'Server down!',
          badge: 'Resolved',
          text: 'Region 1: Server crashed!',
          time: new Date('11/06/2018'),
          status: 'danger',
          link: '/dashboard/v3'
        }
      ];
    }
  
    ngOnInit() {
      this.setUserInfo(this.auth.getStoredUserInfo());
  
      this.auth.userInfoChange.subscribe(userInfo => {
        this.setUserInfo(userInfo);
      });
    }

    setUserInfo(user) {
      this.user = user;
      this.selectedSuiteCode = this.user.suiteCodes[0];
      this.showSuiteSelection = this.user.suiteCodes.length > 1;
    }
  
    toggelSidebar() {
      const state = this.navService.sidebarState;
      if (state.childnavOpen && state.sidenavOpen) {
        return state.childnavOpen = false;
      }
      if (!state.childnavOpen && state.sidenavOpen) {
        return state.sidenavOpen = false;
      }
      // item has child items
      if (!state.sidenavOpen && !state.childnavOpen 
        && this.navService.selectedItem.type === 'dropDown') {
          state.sidenavOpen = true;
          setTimeout(() => {
              state.childnavOpen = true;
          }, 50);
      }
      // item has no child items
      if (!state.sidenavOpen && !state.childnavOpen) {
        state.sidenavOpen = true;
      }
    }
  
    signout() {
      this.auth.signout();
    }

    selectChangeHandler(value, content) {
      //update the ui
      this.selectedSuiteCode = value;
      
      if(content)
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' })
          .result.then((result) => {
            console.log(result);
          }, (reason) => {
            console.log('Err!', reason);
          });
    }
  
    copyAddress(addressElement) {
      let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = addressElement.innerHTML;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.toastr.success('Address copied', '', {
        positionClass: 'toast-top-center',
        progressBar: true
      });
    }

    loginOldSystem(){
      this.settingsService.loginToOldSystem().subscribe((res:any)=>{
        window.location.href = res.url;
      }, err =>{
        console.log(err);
      });
    }

}
